import { users } from '@mep/pae-commons';
import { Select } from 'antd';
import compose from 'lodash/fp/compose';
import map from 'lodash/fp/map';
import values from 'lodash/values';
import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const { USER_ACCESS_LEVELS } = users;

const UserAccessLevelSelect = ({ value, onChange }) => {
  const { t } = useTranslation('common');
  
  const options = useMemo(() => compose(
    map((value) => ({ value, label: t(`accessLevel.${value}`) })),
    values,
  )(USER_ACCESS_LEVELS), [t]);
  
  return (
    <Select
      value={value}
      options={options}
      onChange={onChange}/>
  );
  
};

UserAccessLevelSelect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  related: PropTypes.string,
};

UserAccessLevelSelect.defaultProps = {};

export default memo(UserAccessLevelSelect);
